// Phase 3D.1-B4-B - Pure, dependency-free contract validator for GET /api/demo/savoie.
// Strict validation of the five explicit metadata fields + disclaimer + records shape.
// No network, no import side effects, no fabrication. Returns an explicit reason.

export const SAVOIE_DEMO_DISCLAIMER =
  "Données synthétiques utilisées uniquement pour une démonstration. " +
  "Aucune affiliation avec une organisation réelle.";

// The five explicit metadata fields expected verbatim (simulation MUST be false:
// historical synthetic observations are NOT a simulation).
export const EXPECTED_META = Object.freeze({
  is_demo: true,
  provenance: "synthetic_demo",
  provenance_label: "DONNÉES DE DÉMONSTRATION",
  affiliation: "none",
  simulation: false,
});

/**
 * Validate the endpoint payload against the strict demo contract.
 * @returns {{ valid: boolean, reason: string|null }}
 *          reason is "invalid_contract" when any field is missing/wrong.
 */
export function validateSavoieDemoContract(payload) {
  if (!payload || typeof payload !== "object") {
    return { valid: false, reason: "invalid_contract" };
  }
  const meta = payload.meta;
  if (!meta || typeof meta !== "object") {
    return { valid: false, reason: "invalid_contract" };
  }
  if (meta.is_demo !== true) return { valid: false, reason: "invalid_contract" };
  if (meta.provenance !== "synthetic_demo") return { valid: false, reason: "invalid_contract" };
  if (meta.provenance_label !== "DONNÉES DE DÉMONSTRATION") {
    return { valid: false, reason: "invalid_contract" };
  }
  if (meta.affiliation !== "none") return { valid: false, reason: "invalid_contract" };
  // simulation is REQUIRED and MUST be strictly false for this historical dataset.
  if (meta.simulation !== false) return { valid: false, reason: "invalid_contract" };
  if (payload.disclaimer !== SAVOIE_DEMO_DISCLAIMER) {
    return { valid: false, reason: "invalid_contract" };
  }
  if (!Array.isArray(payload.records)) {
    return { valid: false, reason: "invalid_contract" };
  }
  return { valid: true, reason: null };
}
